export default __webpack_public_path__ + "static/media/manta-stake.ddb9844a.png";